import React from "react";

const ImageGrid = ({ data, onCreate, onDelete }) => {
  return (
    <section className="content container-fluid mt-4">
      <div className="row">
        <div className="col-lg-8 col-md-10 col-sm-12 col-xs-12 col-lg-offset-2 col-md-offset-1">
          <div className="box box-primary">
            <div className="box-header with-border d-flex justify-content-between align-items-center">
              <h3>News Upload</h3>
              <button className="btn btn-primary mb-3" onClick={onCreate}>
                Upload News Image
              </button>
              <div className="box-body">
                <table className="table table-bordered table-striped">
                  <thead>
                    <tr>
                      <th>#</th>
                      <th>Image</th>
                      <th>Actions</th>
                    </tr>
                  </thead>
                  <tbody>
                    {data.length === 0 ? (
                      <tr>
                        <td colSpan="5" className="text-center">
                          No entries found.
                        </td>
                      </tr>
                    ) : (
                      data?.map((image, index) => (
                        <tr key={index}>
                          <td>{index + 1}</td>

                          <td>
                            {image.filename && (
                              <img
                                src={"../assets/gallary/" + image.filename}
                                alt="Preview"
                                style={{
                                  height: "100px",
                                  width: "100px",
                                  borderRadius: 6,
                                }}
                              />
                            )}
                          </td>
                          <td>
                            <button
                              className="btn btn-danger btn-sm"
                              onClick={() => onDelete(index)}
                            >
                              Delete
                            </button>
                          </td>
                        </tr>
                      ))
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ImageGrid;
